const env = require("../../../.github/env-staging.json");

function loadEnvStaging() {
  return process.env.GATSBY_ENV === "prod" ? {} : env;
}

module.exports = loadEnvStaging;
